import CertsGlobalError from './CertsGlobalError';

export default CertsGlobalError;
